import moment from 'moment';

export const ERROR = {
  max: 'Enter value more than min',
  min: 'Enter value less than max',
  from: 'From date must be before To date',
  to: 'To date must be after From date',
  invalidDate: 'Please enter in a date (YYYY-MM-DD)',
};

const isEmpty = val => !val && val !== 0;

const RangeValidator = {
  validateMinMax: (type, min, max) => {
    let isValid;
    if (isEmpty(min) || isEmpty(max)) {
      isValid = true;
    } else {
      isValid = min <= max;
    }
    return !isValid ? ERROR[type] : '';
  },
  isDateValid: (dateValue) => {
    const isValid = dateValue && moment(dateValue, 'YYYY-MM-DD', true).isValid();
    return !isValid ? ERROR.invalidDate : '';
  },
  validateDateFromTo: (type, from, to) => {
    if (!from && !to) return '';
    const momentFrom = moment(from);
    const momentTo = moment(to);
    return !momentTo.isSameOrAfter(momentFrom) ? ERROR[type] : '';
  }
};

export default RangeValidator;